import gql from 'graphql-tag';

export default () => gql`
  query {
    getTenantTrunkType(dummy: "") {
      tenantDetailList {
        name
        value
      }
    }
  }
`;
